<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: ForgotPassword Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img v-if="setForgotPasswordPageImage" :src="img_cdn + setForgotPasswordPageImage" alt="login" class="mx-auto">
            </div>


            <div v-if="verifyEmailStatus" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Your Email</h4>
                  <p class="mb-4">Enter your email address to update your account password.</p>
                  <!--                  <p>Your are re.</p>-->
                </div>
                <div>
                  <vs-input
                    v-validate="'required|email'"
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Enter Email"
                    v-model="DataEmail"
                    class="w-full"/>

                  <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

                  <br>
                  <br>

                  <router-link to="/login">
                    <vs-button type="border">Cancel</vs-button>
                  </router-link>
                  <vs-button class="float-right" :disabled="!validateForm" @click="submitData">Submit</vs-button>
                  <br>
                </div>
              </div>
            </div>

            <div v-if="sentSuccess" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Email sent Successfully!</h4>
                  <!--                  <p>Your are re.</p>-->
                </div>
                <div>

                  <p>Password reset link sent kindly check your email to update password.</p>
                  <br>
<!--                  <router-link to="/login">-->
<!--                    <vs-button class="float-right" type="border">Login</vs-button>-->
<!--                  </router-link>-->
<!--                  <vs-button class="float-right" @click="submitData">Login</vs-button>-->
                  <br>
                </div>
              </div>
            </div>


          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {GET_IMAGE_SETTING, PASSWORD_RESET_EMAIL} from '@/graphql'


export default {
  data() {
    return {
      sentSuccess:false,
      invalidEmail:false,
      verifyEmailStatus:true,
      DataEmail:'',
      img_cdn:process.env.VUE_APP_IMAGES_CDN_LINK,
      setForgotPasswordPageImage:''

    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.DataEmail !== ''
    }
  },
  methods: {

    submitData() {
      this.$apollo
        .mutate({
          mutation: PASSWORD_RESET_EMAIL,
          variables: {
            email: this.DataEmail
          }
        })
        .then(response => {
          if (response.data.forgotPassword.status=='EMAIL_NOT_SENT'){
            this.invalidEmail=false
            this.verifyEmailStatus=true
            // this.$router.replace('/login')
            this.emailNotFoundNotification  ()
          }
          else if (response.data.forgotPassword.status=='EMAIL_SENT'){
            this.invalidEmail=false
            this.verifyEmailStatus=false
            this.sentSuccess=true

            // this.$router.replace('/login')
            this.SuccessStatus()
          }
        }) .catch(error => {
        this.invalidEmail=true
        this.verifyEmailStatus=true
        this.StatusInvalid()
      });

    },
    SuccessStatus() {
      this.$vs.notify({
        title: "Email Sent",
        text: 'We have emailed your password reset link! ',
        color: 'success',
        position: 'top-right'
      })

    },
    StatusInvalid() {

      this.$vs.notify({
        title: "Incorrect Data",
        text: 'Check and Enter again',
        color: 'danger',
        position: 'top-right'
      })
    },
    emailNotFoundNotification() {

      this.$vs.notify({
        title: "Email Not Found",
        text: 'We can not find a user with that email address.',
        color: 'danger',
        position: 'top-right'
      })
    },

  },
  beforeCreate() {
    this.$apollo
      .query({
        query: GET_IMAGE_SETTING,
      })
      .then(response => {
        if (response.data.getImagesSetting.forgot_password_page_image != null) {
          this.setForgotPasswordPageImage = response.data.getImagesSetting.forgot_password_page_image
        }
      })
      .catch(error => {
        console.log(error)
      });
  }

}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}
</style>
